import React from 'react';
import PropTypes from 'prop-types';
import { useVendorInitApplication } from '../../../../Lib/Hooks/vendor-application.hooks.ts';
import VendorProfile from '../../../ReusableComponents/VendorProfile/VendorProfile.tsx';

function InitiateApplication({ currentUser, onSubmit }) {
  const vendorInitApplication = useVendorInitApplication({
    successCb: onSubmit,
  });

  const handleSubmit = (data) => {
    vendorInitApplication.mutate({
      requesterId: data.requester_id,
      requesterName: data.requester_name,
      sponsorId: data.sponsor_id,
      vendorType: data.vendor_type_category,
      legalName: data.legal_name,
      divisions: data.divisions,
      existingVendor: data.existing_vendor,
      primaryContact: {
        firstName: data.primary_contact_firstname,
        lastName: data.primary_contact_lastname,
        title: data.primary_contact_title,
        email: data.primary_contact_email,
      },
      dba: data.doing_business_as,
    });
  };

  return (
    <VendorProfile
      creatorName={`${currentUser.first_name} ${currentUser.last_name}`}
      isLoading={false}
      handleSubmit={handleSubmit}
      submitText="Submit"
      currentUser={currentUser}
      title="Start a Vendor Application"
    />
  );
}

InitiateApplication.propTypes = {
  currentUser: PropTypes.shape({
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default InitiateApplication;
